<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-xl-4 col-lg-6">
                <div class="widget-card widget-l-bg-blue-dark">
                    <div class="widget-card-statistic-3 p-4">
                        <div class="widget-card-icon widget-card-icon-large">
                            <icon class="fas" icon="users"></icon>
                        </div>
                        <div class="mb-4">
                            <h5 class="widget-card-title mb-0">{{ $t('NUMBEROFGROUPS') }}</h5>
                        </div>
                        <div class="row align-items-center mb-2 d-flex">
                            <div class="col-8">
                                <h2 class="d-flex align-items-center mb-0">
                                    {{ statistics.numberOfGroups }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-6">
                <div class="widget-card widget-l-bg-cherry">
                    <div class="widget-card-statistic-3 p-4">
                        <div class="widget-card-icon widget-card-icon-large">
                            <icon class="fas" icon="users"></icon>
                        </div>
                        <div class="mb-4">
                            <h5 class="widget-card-title mb-0">{{ $t('ACTIVEUSERS') }}</h5>
                        </div>
                        <div class="row align-items-center mb-2 d-flex">
                            <div class="col-8">
                                <h2 class="d-flex align-items-center mb-0">
                                    {{ statistics.childrenCnt }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-6">
                <div class="widget-card widget-l-bg-blue-dark">
                    <div class="widget-card-statistic-3 p-4">
                        <div class="widget-card-icon widget-card-icon-large">
                            <icon class="fas" icon="info"></icon>
                        </div>
                        <div class="mb-4">
                            <h5 class="widget-card-title mb-0">{{ $t('NUMEROFEVENTSMONTH') }}</h5>
                        </div>
                        <div class="row align-items-center mb-2 d-flex">
                            <div class="col-8">
                                <h2 class="d-flex align-items-center mb-0">
                                    {{ statistics.monthArrivalRecord }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-6">
                <div class="widget-card widget-l-bg-green-dark">
                    <div class="widget-card-statistic-3 p-4">
                        <div class="widget-card-icon widget-card-icon-large">
                            <icon class="fas" icon="chart-line"></icon>
                        </div>
                        <div class="mb-4">
                            <h5 class="widget-card-title mb-0">{{ $t('NUMEROFEVENTSTOTAL') }}</h5>
                        </div>
                        <div class="row align-items-center mb-2 d-flex">
                            <div class="col-8">
                                <h2 class="d-flex align-items-center mb-0">
                                    {{ statistics.totalArrivalRecord }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-6">
                <div class="widget-card widget-l-bg-blue-dark">
                    <div class="widget-card-statistic-3 p-4">
                        <div class="widget-card-icon widget-card-icon-large">
                            <icon class="fas" icon="chart-line"></icon>
                        </div>
                        <div class="mb-4">
                            <h5 class="widget-card-title mb-0">{{ $t('NUMEROFEVENTSFORUSER') }}: {{ globals.username }}</h5>
                        </div>
                        <div class="row align-items-center mb-2 d-flex">
                            <div class="col-8">
                                <h2 class="d-flex align-items-center mb-0">
                                    {{ statistics.numberOfEventPerUser }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-green">
            <div class="card-header">
                <strong>{{ $t('NOTIFICATIONS') }}</strong>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12  table-responsive">
                        <table class="table table-bordered table-striped table-hover table-sm table-logoped">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>
                                        {{ $t('TITLE') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="item in response.root">
                                    <tr :key="item.notificationId" aria-rowindex="1" class=" table-ellipsis">
                                        <td>
                                            <icon v-if="item.isExpanded === false" @click="item.isExpanded = true"
                                                icon="plus" class="hover-mouse"></icon>
                                            <icon v-if="item.isExpanded === true" @click="item.isExpanded = false"
                                                icon="minus" class="hover-mouse"></icon>
                                        </td>
                                        <td>{{ item.title }}</td>
                                    </tr>
                                    <tr v-if="item.isExpanded === true" :key="`${item.notificationId}_sec`"
                                        class=" table-ellipsis">
                                        <td></td>
                                        <td v-html="item.message" colspan="1"></td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                        <nav>
                            <pagination v-bind:totalCount="response.totalCount" v-model="pagination"
                                v-on:reload="getNotificationData">
                            </pagination>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapGetters,
}
    from 'vuex';
import EventsApi from '@/api/child/Events';
import NotificationApi from '@/api/notifications/Notifications.js';
export default
    {
        name: 'dashboard',
        data() {
            return {
                response:
                    {},
                statistics: {},
                pagination:
                {
                    query: '',
                    currentPage: 1,
                    limit: 25,
                    searchTimeout: false,
                    showInactive: 0,
                },
            };
        },
        async created() {
            const me = this;
            await me.getStatistics();
            me.getNotificationData();

            me.$subscribe(`notification`, (data) => {
                me.getNotificationData();
            });
        },
        methods:
        {
            async getNotificationData() {
                const me = this;
                try {
                    const data = await NotificationApi.selectRow(me.getParams);
                    if (data.error && data.error === true) {
                        me.$notify.notice(data);
                        me.loading = false;
                        return;
                    }

                    for (const item of data.root) {
                        item.isExpanded = false;
                    }

                    me.response = data;
                }
                catch (e) {
                    me.$notify.notice(e);
                }
            },
            async getStatistics() {
                const me = this;
                try {
                    const data = await EventsApi.getStatistics();
                    if (data.error && data.error === true) {
                        throw (data);
                    }

                    me.statistics = data.root;
                }
                catch (e) {
                    me.$notify.notice(e);
                }
            },
        },
        watch:
        {
            'pagination.limit'() {
                const me = this;
                me.getNotificationData();
            },
            'pagination.currentPage'() {
                const me = this;
                me.getNotificationData();
            },
            'pagination.query'() {
                const me = this;

                if (me.pagination.searchTimeout !== false) {
                    clearTimeout(me.pagination.searchTimeout);
                }

                me.pagination.searchTimeout = setTimeout(() => {
                    me.getNotificationData();
                    me.pagination.searchTimeout = false;
                }, 300);
            },
        },
        computed:
        {
            ...mapGetters([
                'globals',
            ]),
            getParams() {
                const me = this;
                const data = {
                    ...me.pagination,
                };
                data.start = (data.currentPage - 1) * data.limit;
                return data;
            },
        },
    };
</script>
